export enum FormGroupStyling {
    COMPACT = '-sh-condensed',
    NO_MARGIN = 'sh-clear-margin',
    SINGLE_LINE = 'sh-form-group__row'
}
